// Mock data for Riva Build Group - Los Angeles Construction Firm
// All images are AI-generated (Gemini Nano Banana) cinematic renders of LA / Malibu villas.

export const sections = [
  { id: 'home', label: 'Home' },
  { id: 'custom-homes', label: 'Custom Homes' },
  { id: 'developments', label: 'Developments' },
  { id: 'releases', label: 'Releases' },
  { id: 'new-build', label: 'New Build' },
  { id: 'renovations', label: 'Renovations' },
  { id: 'vision', label: 'Vision' },
  { id: 'contact', label: 'Contact' },
];

export const heroPoster = '/ai/hero_poster.png';
export const customHomesImage = '/ai/custom_homes.png';
export const developmentsImage = '/ai/developments.png';
export const newBuildImage = '/ai/new_build.png';
export const renovationsImage = '/ai/services_intro.png';
export const visionImage = '/ai/vision.png';
export const ctaImage = '/ai/cta.png';
export const aboutImage = '/ai/cta.png';

export const upcomingReleases = [
  {
    id: 'malibu-cliff',
    name: 'Malibu Cliff Residence',
    location: 'Malibu, CA',
    year: 'Coming 2026',
    typology: 'Oceanfront Modern',
    size: 'c. 9,800 sqft',
    status: 'In Design',
    image: '/ai/release_malibu_cliff.png',
  },
  {
    id: 'bel-air-hillside',
    name: 'Bel Air Hillside',
    location: 'Bel Air, CA',
    year: 'Coming 2026',
    typology: 'Hillside Estate',
    size: 'c. 12,400 sqft',
    status: 'In Design',
    image: '/ai/release_bel_air.png',
  },
  {
    id: 'pacific-pavilion',
    name: 'Pacific Pavilion',
    location: 'Malibu, CA',
    year: 'Coming 2027',
    typology: 'Oceanfront Glass House',
    size: 'c. 7,200 sqft',
    status: 'Pre-Design',
    image: '/ai/release_pacific.png',
  },
  {
    id: 'laurel-canyon',
    name: 'Laurel Canyon Residence',
    location: 'Hollywood Hills, CA',
    year: 'Coming 2027',
    typology: 'Wooded Canyon',
    size: 'c. 6,400 sqft',
    status: 'Pre-Design',
    image: '/ai/release_canyon.png',
  },
  {
    id: 'mid-century-restoration',
    name: 'Trousdale Restoration',
    location: 'Beverly Hills, CA',
    year: 'Coming 2026',
    typology: 'Mid-Century Restoration',
    size: 'c. 5,600 sqft',
    status: 'In Design',
    image: '/ai/release_midcentury.png',
  },
  {
    id: 'coastal-retreat',
    name: 'Zuma Coastal Retreat',
    location: 'Malibu, CA',
    year: 'Coming 2027',
    typology: 'Single-Story Coastal',
    size: 'c. 4,800 sqft',
    status: 'Pre-Design',
    image: '/ai/release_coastal.png',
  },
];

export const features = [
  {
    id: 'custom-homes',
    label: 'Custom Homes',
    title: 'custom homes',
    coord: '34.02\u00b0 N   118.78\u00b0 W',
    description:
      'Craft unforgettable residences tailored to your every desire. From meticulously considered architecture to quietly executed interior finishes, each home is a singular, site-specific work.',
    image: customHomesImage,
  },
  {
    id: 'developments',
    label: 'Developments',
    title: 'developments',
    coord: '34.07\u00b0 N   118.40\u00b0 W',
    description:
      'Small-footprint private developments across Los Angeles. We lead the full arc, from site feasibility and entitlements through design, construction and careful delivery.',
    image: developmentsImage,
  },
  {
    id: 'new-build',
    label: 'New Build',
    title: 'new build',
    coord: '34.02\u00b0 N   118.70\u00b0 W',
    description:
      'From concept to completion, we collaborate with the world\u2019s leading architects and craftsmen to realise residences that reflect your individuality and enduring legacy.',
    image: newBuildImage,
  },
  {
    id: 'renovations',
    label: 'Renovations',
    title: 'renovations',
    coord: '34.09\u00b0 N   118.38\u00b0 W',
    description:
      'Architecturally-led renovations of significant Los Angeles residences \u2014 restoring structure, reconsidering proportion, and gently lifting what is already there.',
    image: renovationsImage,
  },
];
